import {BaseEntity} from "./BaseEntity";

export class ApplicationSetting implements BaseEntity {
    static applicationSetting:ApplicationSetting;
    constructor(public id?: number,
                public version?: string,
                public type?: string,
                public licenseKey?: string,
                public company?: string,
                public lastRfidSerialNumber?: number,
                public lastModifiedBy?:string,
                public temperatureFormat?:string,
                public useMeters?:boolean,
                public assetDisplayColumns?:string,
                public vTagPopupDisplayRows?:string,
                public cmdMapRefresh?:number,
                public cmdActiveTimeout?:number,
                public cmdMapPinZoominEnabled?:boolean,
                public cmdMapPinDisplacePixels?:number,
                public eventTrim?:number,
                public alarmTrim?:number,
                public sensorReadingTrim?:number,
                public locationHistoryTrim?:number,
                public commandTrim?:number,
                public sensorStatTrim?: number,
                public mqttEnabled?: boolean,
                public smtpEmailEnableSSL?:boolean,
                public smtpEmailFrom?:string,
                public smtpEmailHost?:string,
                public smtpEmailPassword?:string,
                public smtpEmailPort?:number,
                public smtpEmailTo?:string,
                public smtpEmailUsername?:string,
                public emailMethod?:string,
                public emailCloudUsername?:string,
                public emailCloudPassword?:string,
                public twoFactorAuthEnabled?:boolean,
                public authenticationServer?:string,
                public dateFormat?:string,
                public vTagPositionReportingMode?:string,
                public alarmUnassociatedAssets?:boolean,
                public vTagGpsServerAddress?:string,
                public vTagGpsServerPort?:number,
                public vTagGpsServerUsername?:string,
                public vTagGpsServerPassword?: string,
                public defaultCheckoutLocationId?: number,
                public defaultCheckinLocationId?: number,
                public automaticallySerializeAssetName:boolean = false,
                public assetNameSerialPrefix:string="AWRX",
                public assetNameSerialLength:number = 5,
                public currentAssetNameSerial: number = 1,
                public enableAssetUnseen: boolean = false,
                public enableGlobalAlarmMessages = false,
                public enableGlobalEventMessages = false,
                public enableGlobalGatewayMessages = false,
                public enableGlobalSensorReadingMessages = false,
                public enableGlobalTagMovementMessages = false,
                public enableGlobalTagObservationMessages = false,
                public updateLastInventoriedForMovedAssets = true,
                public fixedTagsMoveToDiffMap = true
    ) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.defaultCheckinLocationId = json.defaultCheckinLocationId;
        this.defaultCheckoutLocationId = json.defaultCheckoutLocationId;
        this.vTagGpsServerAddress = json.vTagGpsServerAddress;
        this.vTagGpsServerPort = json.vTagGpsServerPort;
        this.vTagGpsServerUsername = json.vTagGpsServerUsername;
        this.vTagGpsServerPassword = json.vTagGpsServerPassword;
        this.version = json.version;
        this.type = json.type;
        this.licenseKey = json.licenseKey;
        this.company = json.company;
        this.lastRfidSerialNumber = json.lastRfidSerialNumber;
        this.lastModifiedBy = json.lastModifiedBy;
        this.temperatureFormat = json.temperatureFormat;
        this.useMeters = json.useMeters;
        this.assetDisplayColumns = json.assetDisplayColumns;
        this.vTagPopupDisplayRows = json.vTagPopupDisplayRows;
        this.cmdMapRefresh = json.cmdMapRefresh;
        this.cmdActiveTimeout = json.cmdActiveTimeout;
        this.cmdMapPinZoominEnabled = json.cmdMapPinZoominEnabled;
        this.cmdMapPinDisplacePixels = json.cmdMapPinDisplacePixels == null || json.cmdMapPinDisplacePixels < 1 ? 20 : json.cmdMapPinDisplacePixels;
        this.eventTrim = json.eventTrim;
        this.alarmTrim = json.alarmTrim;
        this.sensorReadingTrim = json.sensorReadingTrim;
        this.locationHistoryTrim = json.locationHistoryTrim;
        this.commandTrim = json.commandTrim;
        this.sensorStatTrim = json.sensorStatTrim;
        this.mqttEnabled = json.mqttEnabled;
        this.smtpEmailEnableSSL = json.smtpEmailEnableSSL;
        this.smtpEmailFrom = json.smtpEmailFrom;
        this.smtpEmailHost = json.smtpEmailHost;
        this.smtpEmailPassword = json.smtpEmailPassword;
        this.smtpEmailPort = json.smtpEmailPort;
        this.smtpEmailTo = json.smtpEmailTo;
        this.smtpEmailUsername = json.smtpEmailUsername;
        this.emailMethod = json.emailMethod;
        this.emailCloudUsername  = json.emailCloudUsername;
        this.emailCloudPassword = json.emailCloudPassword;
        this.twoFactorAuthEnabled = json.twoFactorAuthEnabled;
        this.authenticationServer = json.authenticationServer;
        this.dateFormat = json.dateFormat == null ? "MM-dd-yyyy HH:mm:ss" : json.dateFormat;
        this.vTagPositionReportingMode = json.vTagPositionReportingMode;
        this.alarmUnassociatedAssets = json.alarmUnassociatedAssets;
        this.automaticallySerializeAssetName = json.automaticallySerializeAssetName;
        this.assetNameSerialPrefix = json.assetNameSerialPrefix;
        this.assetNameSerialLength = json.assetNameSerialLength;
        this.currentAssetNameSerial = json.currentAssetNameSerial;
        this.enableAssetUnseen = json.enableAssetUnseen;
        this.enableGlobalAlarmMessages = json.enableGlobalAlarmMessages;
        this.enableGlobalEventMessages = json.enableGlobalEventMessages;
        this.enableGlobalGatewayMessages = json.enableGlobalGatewayMessages;
        this.enableGlobalSensorReadingMessages = json.enableGlobalSensorReadingMessages;
        this.enableGlobalTagMovementMessages = json.enableGlobalTagMovementMessages;
        this.enableGlobalTagObservationMessages = json.enableGlobalTagObservationMessages;
        this.updateLastInventoriedForMovedAssets = json.updateLastInventoriedForMovedAssets;
        this.fixedTagsMoveToDiffMap = json.fixedTagsMoveToDiffMap;
    }
}
